import type { AppAction } from "@/types";

export const appOrderLineItemDocumentUploaded: AppAction<{
    emit: (eventName: string) => void;
}> = async (args) => {
    args.emit("order-line-item-document-upload-button-click");
    return true;
};
